import React, { Component } from "react";

// Style
import './HomeStyle.css';

// Components
import MySkills from "../Components/Skills/MySkills";
import MyBlogHome from "../Components/MyBlogHome/MyBlogHome";
import AvilableCard from "../Components/AvilableCard/AvilableCard";
import ContactHome from "../Components/ContactHome/ContactHome";
import MainFooter from "../Components/MainFooter/MainFooter";
import { AdminTools } from "../Components/AdminTools/AdminTools";
import { MainHeaderr } from "../Components/mainHeader/HeaderMain";
import { DropFiles } from "../Components/DropFiles/DropFiles";

/* // Images
import Me from "../assets/imags/me.jpg";
import Logo from '../assets/Icons/Logo.png';
*/

import { ChangedData } from "../assets/ChangedData/ChangedData";

// Servers
import { HomeDataRequest } from "../Components/Service/data";

// Icons
import angleRightSolid from "../assets/Icons/angle-right-solid.svg";
import penToSquare from "../assets/Icons/penToSquare.svg";
import xmark from "../assets/Icons/xmark.svg";
import deleteIcone from "../assets/Icons/delete.svg";
import plusSolid from "../assets/Icons/plusSolid.svg";
import hourglass from "../assets/Icons/hourglass.svg";

// Images
import myFoto from "../assets/imags/me.jpg";

// Json Data
import { fetchAllDataHome } from "../Components/Service/data";


import { SketchPicker } from "react-color";

export var AllData = {}
export var skill; 





















class Home extends Component{

    i = 0;
    char = 0;
    TopNum = 0;
    myBeruf = "";
    mySkills = <MySkills />;


    constructor(props){
        
        super(props);
        this.state = {
            myBeruf : "",
            //HomeBlogsObjects: [],
            AdminTools: "" ,
            // AllEditsArray: [] ,
            // Tool Admin Div
            toolDiv: "",

            // Json Data to UI
            DataH: {},
            AboutMeHome: [] ,

            // About me Home Keys and Values
            AboutMeHomeRender: "" ,
            AboutMeHomeRenderValues: "" ,
            AboutMeHomeRenderKeysForATool: "" ,

            SkillsRendTitls: "",

            NewSkill: "" ,
            ATSkillsCards: [] ,

            ConcatTitlesATool : "" ,

            fromInputsATool: ""
        }


        this.ToolSectionsHandel = this.ToolSectionsHandel.bind(this);
        this.clickToEditAtUi = this.clickToEditAtUi.bind(this);
        this.renderBerufeATool = this.renderBerufeATool.bind(this);
        this.AdminTooldeletBeruf = this.AdminTooldeletBeruf.bind(this);
        this.addNewBeruf = this.addNewBeruf.bind(this);
        this.OkAdminToolBTN = this.OkAdminToolBTN.bind(this);
        this.onHoverTargetElement = this.onHoverTargetElement.bind(this);
        this.renderTAT = this.renderTAT.bind(this);
        this.openBerufeEdit = this.openBerufeEdit.bind(this);
        this.renderAbouteMeLines = this.renderAbouteMeLines.bind(this);
        this.removeAboutLine = this.removeAboutLine.bind(this);
        this.AddNewLineBTNHandel = this.AddNewLineBTNHandel.bind(this);
        this.renderAdminToolSec = this.renderAdminToolSec.bind(this);
        this.removeSkilssAb = this.removeSkilssAb.bind(this);
        this.renderAToolSkillsCardName = this.renderAToolSkillsCardName.bind(this);
        this.AddSkillF = this.AddSkillF.bind(this);
        this.FinishAddingSkills = this.FinishAddingSkills.bind(this);
        this.OpenAddNewSkillHand = this.OpenAddNewSkillHand.bind(this);
        this.renderContactTitles = this.renderContactTitles.bind(this)
        this.removeContactCard = this.removeContactCard.bind(this);
        this.addNewContactCard = this.addNewContactCard.bind(this);
        this.OKAddContactCardBTN = this.OKAddContactCardBTN.bind(this);
        this.rendFormInputs = this.rendFormInputs.bind(this);



        window.addEventListener("scroll" , ()=>{
            this.AboutMeAnimation();
        });

    }

    async fetchAllData(){
        const allFiles = ["HomeData" , "AboutMeHome"];
        const stateKey = ["DataH" , "AboutMeHome"];


        setTimeout(() => {
            fetchAllDataHome(allFiles[0]).then(data =>{

            });
        }, 100);




        await fetch(`${process.env.PUBLIC_URL}/mydata/`+ allFiles[0] + ".json").then((r) => r.json()).then((data) =>{
            AllData[allFiles[0]] = data;
            this.state[stateKey[0]] = data;
        }).finally( ()=>{
            this.TypingLoop();
            if (localStorage.getItem("isLogged") == "true") {
                this.renderBerufeATool();
                this.renderTAT();
                this.rendFormInputs();
            }
        });


        await fetch(`${process.env.PUBLIC_URL}/mydata/`+ allFiles[1] + ".json").then((r) => r.json()).then((data) =>{
            AllData[allFiles[1]] = data;
            this.state[stateKey[1]] = data;
        }).finally(()=>{
            if (localStorage.getItem("isLogged") == "true") {
                this.renderAbouteMeLines();
            }
            this.renderAMH();
        });
    }

    componentDidMount(){
        this.fetchAllData();

        window.addEventListener("DOMContentLoaded" , ()=>{
            this.AnimationsHome();
            if (this.state.myBeruf.length > 0) {
                this.TypingLoop();
            }
            setTimeout(() => {
                let AllBody = document.getElementById("AllBody");
                AllBody.classList.remove("AllBodyAus");
            }, 400);
            this.renderToolDivOnScroll();

            if (localStorage.getItem("isLogged") == "true") {
                let AdminTool = document.querySelector("#AdminTool");
                AdminTool.classList.remove("AdminToolZuu");
    
                const intervaly = setInterval(() => {
                    if (AllData.SkillsTitles != undefined && AllData.SkillsTitles.length > 0) {
                        this.renderAdminToolSec();
                        clearInterval(intervaly);
                    }
                }, 100);
                setTimeout(() => {
                    if (AllData.SkillsTitles.length <= 0) {
                        clearInterval(intervaly);
                    }
                }, 5000);

                setTimeout(() => {
                    this.renderContactTitles();
                }, 1000);
            }

            document.getElementById("AddSkillF").addEventListener("click" , ()=>{
                this.renderAToolSkillsCardName();
            })
        });
    
    }


    renderAMH(){
        this.state.AboutMeHomeRender =   this.state.AboutMeHome.ky995AMH.map( (title , index) => <p className="AbmeMainInfoLabels editCursurOnHover" ind={index} id={index}  onClick={this.toTextEditFunction} data-f="AboutMeHome" ky-or-vl="ky995AMH"  > { title } </p> )
        this.state.AboutMeHomeRenderValues =   this.state.AboutMeHome.val995AMH.map( (value , index) =>  <p className="AbmeMainInfotxt editCursurOnHover" ind={index} onClick={this.toTextEditFunction} data-f="AboutMeHome" ky-or-vl="val995AMH" > { value } </p> )
    }

    ToolsZu(){
        let editIconAT = document.querySelector("#editIconAT");
        editIconAT.classList.toggle("editIconAT");

        let AdminTool = document.querySelector("#AdminTool");
        AdminTool.classList.toggle("AdminToolOpen");
    }

    TypingLoop(){ 
        this.setState({
            myBeruf : this.myBeruf
        });
        // Type
        this.myBeruf += this.state.DataH.myBerufe[this.i][this.char];
        this.char++;
        
        // Loop Time 
        let LoopTime = setTimeout(() => {
          this.TypingLoop();
        }, this.state.DataH.Timeing);
    
        // isDeleteing If Typed Full Word
        if(this.state.DataH.myBerufe[this.i].length == this.char){
          clearTimeout(LoopTime);
          setTimeout(() => {
            this.DeleteFunction();
          }, this.state.DataH.waitTime);
        }
    }

    //Delete Function
    DeleteFunction(){
        this.setState({
            myBeruf : this.myBeruf
        });
        // Delete Code
        this.myBeruf = this.myBeruf.substr(0 , this.char - 1);
        this.char = this.char - 1;

        // Time Of Delete 1 Char
        let DeleteLoop = setTimeout(() => {
        this.DeleteFunction();
        }, this.state.DataH.DeleteTime);
        
        // If Finish Deleting
        if(this.char < 0){
            this.char = 0;
            this.i++;
            // Repeat Words Array
            if( this.i == this.state.DataH.myBerufe.length) {
                this.i = 0;
            }
            clearTimeout(DeleteLoop);
            this.TypingLoop();
        }
    }

    AnimationsHome(){
        let WelcomScreenContainer = document.getElementById("WelcomScreenContainer");
        let Name = document.getElementById("Name");

        WelcomScreenContainer.style.transform = "translateY(-40px)";
        WelcomScreenContainer.style.opacity = 1;

        setTimeout(() => {
            Name.style.transform = "scale(1.15)";
        }, 250);
        setTimeout(() => {
            Name.style.transform = "scale(1)";
        }, 700);
    }
   
    AboutMeAnimation(){
        let AbuteMeInfoDiv = document.getElementById("AbuteMeInfoDiv");
        let WindowH = window.innerHeight;
        let AbuteMeInfoDivTOP = AbuteMeInfoDiv.getBoundingClientRect().top;
        let CVbtn = document.getElementById("CVbtn");
        let PAImage = document.getElementById("PAImage");

        if (WindowH > AbuteMeInfoDivTOP + 30 ) {
            AbuteMeInfoDiv.style.transition = "0.8s";
            AbuteMeInfoDiv.style.transform = "translateY(0px)";
            AbuteMeInfoDiv.style.opacity = 1;

            setTimeout(() => {
                CVbtn.style.transform = "translateY(0px)";
                CVbtn.style.opacity = 1;
                AbuteMeInfoDiv.style.transition = "0s";
            }, 400);

            PAImage.style.transform = "scale(1)";
        }

    }

    toTextEditFunction(event){
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";
    

            toTextEdit.addEventListener("focusout" , ()=> {
                
                if ( textArea.value.length > 0) {
                    let NewValueTextarea = textArea.value
                    toTextEdit.innerHTML = NewValueTextarea;
                    // file name
                    let APIfileName = event.target.getAttribute("data-f");
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;

                    AllData[APIfileName][atributname] = textafter;

                    if (Oldtext != textafter) {
                        let SaveChangContainer = document.getElementById("SaveChangContainer");
                        SaveChangContainer.style.visibility = "visible";

                        if ( !ChangedData[APIfileName]) {
                            ChangedData[APIfileName] = AllData[APIfileName];
                        }
                    }

                    if (APIfileName = "AboutMeHome") {
                        let KeyOrValue = event.target.getAttribute("ky-or-vl");
                        let index = event.target.getAttribute("ind");
                        if (KeyOrValue) {
                            AllData[APIfileName][KeyOrValue][index] = textafter;
                        }
                    }
                    
                }else{
                    // return old Text
                    toTextEdit.innerHTML = Oldtext;
                }
            });
            
            toTextEdit.addEventListener("keydown" , ()=> {
                textArea.style.width = "max-content";
                textArea.style.height = "max-content";
            });
        }
    }

    hoverEditOn(event){
        if (localStorage.getItem("isLogged") == "true") {

            event.target.classList.add("editCursurOnHover");

            /*
            let TargetElement = event.target;
            // TargetElement.innerHTML += '<div className=""></div>';
            //myDiv.appendChild(<i className="fas fa-wrench editIcon"></i>)
            let inn = TargetElement.classList[0];
            let lengthOf = document.querySelectorAll("."+inn+" .EditLogoContainer");
    
            if (lengthOf.length == 0) {
                TargetElement.style.position = "relative";
                
                let myDiv = document.createElement("div");
                TargetElement.appendChild(myDiv);
                myDiv.classList.add("EditLogoContainer");
    
                let Icon = document.createElement("i");
                Icon.classList.add("fas");
                Icon.classList.add("fa-wrench");
                Icon.classList.add("editIcon");
                myDiv.appendChild(Icon);
    
                // cheek Window 
                let myDivLeft = myDiv.getBoundingClientRect().right;
                let myDivTop = myDiv.getBoundingClientRect().top;
    
                if ( myDivLeft < 30) {
                    myDiv.classList.add("EditLogoContainerLeft");
                }else{
                    myDiv.classList.remove("EditLogoContainerLeft");
                }
                if (myDivTop < 30) {
                    myDiv.classList.add("EditLogoContainerTop");
                }else{
                    myDiv.classList.remove("EditLogoContainerTop");
                }
            }
            */
        }
    }

    hoverEditOut(event){
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }

    uploadChangedDataToServer(){


        setTimeout(() => {
            let allKeys = Object.keys(ChangedData);

            for (let i = 0; i < allKeys.length; i++) {
                let ContenttoStr = JSON.stringify(ChangedData[allKeys[i]]);
                let FileNameToStr = allKeys[i];

                // API Request
                HomeDataRequest(FileNameToStr , ContenttoStr).then( respo => {
                    // Do somthing to know if data Changed
                });
            }

            // Close SaveView
            let SaveChangContainer = document.getElementById("SaveChangContainer");
            SaveChangContainer.style.visibility = "hidden";
        }, 50);
    }

    CloseSaveChange(){
        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "hidden";
    }

    // Remove this Function
    renderToolDivOnScroll(){
        if (localStorage.getItem("isLogged") == "true") {
            let WindowH = window.innerHeight / 4;
            window.addEventListener("scroll" , ()=>{
                this.state.toolDiv = "";
                let HomeTop = document.getElementById("Home").getBoundingClientRect().top;
                let SkillsTop = document.getElementById("mySkillsComp").getBoundingClientRect().top;
                let BolgsTop = document.getElementById("MyBlogHomeComp").getBoundingClientRect().top;
                let FreeLaTop = document.getElementById("AvilableCardComp").getBoundingClientRect().top;
                let ContactTop = document.getElementById("ContactHomeComp").getBoundingClientRect().top;
            })
        }
    }

    ToolSectionsHandel(event){
        let welcheClass = event.target.getAttribute("ToolA");
        // Animations
        const allSectiosContainer =document.getElementById("allSectiosContainer");
        allSectiosContainer.classList.add("allSectiosContainerAus");
        const AdminToolSecessAnimations = document.getElementById(`${welcheClass}`);
        
        setTimeout(() => {
            allSectiosContainer.classList.add("allSectiosContainerAus2");
            AdminToolSecessAnimations.classList.remove(welcheClass);
        }, 220);
    }
    CloseToolSectionsHandel(event){
        let welcheClass = event.target.getAttribute("ToolA");
        // Animations
        const AdminToolSecessAnimations = document.getElementById(welcheClass);
        AdminToolSecessAnimations.classList.add(welcheClass);
        
        const allSectiosContainer = document.getElementById("allSectiosContainer");
        allSectiosContainer.classList.remove("allSectiosContainerAus2");

        setTimeout(() => {
            allSectiosContainer.classList.remove("allSectiosContainerAus");
        }, 10);
    }
    
    clickToEditAtUi(event){
        var Uitarget = event.target.getAttribute("uitarget");
        document.getElementById(Uitarget).click();
        this.ToolsZu();
    }

    renderBerufeATool(){
        const InputsContainerBerAT = document.getElementById("InputsContainerBerAT");

        for (let i = 0; i < this.state.DataH.myBerufe.length; i++){
            const inputContainer = document.createElement("div");
            InputsContainerBerAT.appendChild(inputContainer);
            const ContainerClases = ["d-flex" , "justify-content-between" , "align-items-center" , "InputsContainerBerAT"];
            for (let j = 0; j < ContainerClases.length; j++) {
                inputContainer.classList.add(ContainerClases[j]);
            }

            const myInput = document.createElement("input");
            inputContainer.appendChild(myInput);

            const deleteIcon = document.createElement("img");
            inputContainer.appendChild(deleteIcon);

            deleteIcon.classList.add("deleteIcon");
            deleteIcon.src = deleteIcone;
            deleteIcon.setAttribute("indexOB" , i);
            deleteIcon.addEventListener("click" , ()=>{
                this.AdminTooldeletBeruf(i);
            })

            myInput.classList.add("inputBer");
            myInput.value = this.state.DataH.myBerufe[i];

            myInput.addEventListener("keydown" , ()=>{
                this.showOkATool();
            });
        }
    }

    AdminTooldeletBeruf(index){
        this.state.DataH.myBerufe.splice(index, 1);

        const InputsContainerBerAT = document.getElementById("InputsContainerBerAT");
        InputsContainerBerAT.innerHTML = "";
        this.renderBerufeATool();
        ChangedData["HomeData"] = AllData["HomeData"];
        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";
    }
    
    addNewBeruf(){
        // Push New Value But Empty 
        this.state.DataH.myBerufe.push(" ");
        // Change ChangedData;
        ChangedData["HomeData"] = AllData["HomeData"];
        
        // Clear all Inputs
        const InputsContainerBerAT = document.getElementById("InputsContainerBerAT");
        InputsContainerBerAT.innerHTML = "";
        // And Create New with the New Input;
        this.renderBerufeATool();
        this.showOkATool();
    }

    showOkATool(){
        const OkATool = document.querySelector("#OkATool");
        OkATool.classList.remove("OkAToolZu");
        OkATool.classList.add("OkATool");
    }

    OkAdminToolBTN(){
        const allInputs = document.getElementsByClassName("inputBer");
        // Reset Data
        this.state.DataH.myBerufe = [];
        for (let i = 0; i < allInputs.length; i++) {
            const values = allInputs[i].value;
            const f1 =  values.trim();
            const f2 = f1 + " ";
            this.state.DataH.myBerufe.push(f2);
        }
        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";

        const TimerInputs = document.getElementsByClassName("TimerInputs");
        const datay = [ "Timeing" , "DeleteTime" , "waitTime"]; 
        for (let n = 0; n < TimerInputs.length; n++) {
            const value = TimerInputs[n].value;
            this.state.DataH[datay[n]] = value;
        }

        // Hide ok Btn
        const OkATool = document.querySelector("#OkATool");
        OkATool.classList.add("OkAToolZu");
        OkATool.classList.remove("OkATool");

        ChangedData["HomeData"] = this.state.DataH;
    }

    onHoverTargetElement(event){
        const target = event.target.getAttribute("uitarget");
        document.getElementById(target).classList.add("targetToEditClass");
    }
    onHoverOutTargetElement(event){
        const target = event.target.getAttribute("uitarget");
        document.getElementById(target).classList.remove("targetToEditClass");
    }

    renderTAT(){
        // get Main Container
        const renderTAT = document.getElementById("renderTAT");
        // Sätze 
        const ss = ["Writing speed: " , "Delete speed: " , "Waiting time: "];
        const data = [ this.state.DataH.Timeing , this.state.DataH.DeleteTime , this.state.DataH.waitTime ];
        const mm = "ms";

        for (let i = 0; i < ss.length; i++) {
            const myDiv = document.createElement("div");
            renderTAT.appendChild(myDiv);

            const myInpute = document.createElement("input");

            myDiv.innerText = ss[i];

            const inpuTcontainer = document.createElement("div");
            inpuTcontainer.classList.add("flex-grow-1");
            myDiv.appendChild(inpuTcontainer);

            myDiv.appendChild(myInpute);

            myInpute.value = data[i];
            myInpute.classList.add("TimerInputs");
            myDiv.classList.add("LableTAT");
            myDiv.classList.add("d-flex");

            const mmSpan = document.createElement("span");
            myDiv.appendChild(mmSpan);
            mmSpan.innerText = mm;

            myInpute.addEventListener("keydown" , ()=>{
                this.showOkATool();
            });

        }

    }

    openBerufeEdit(){
        document.getElementById('Home').scrollIntoView();
        const AToolHomeSec = document.getElementById("AToolHomeSec");
        this.ToolsZu();
        let AdminTool = document.querySelector("#AdminTool");
        AdminTool.classList.add("AdminToolOpen");
        setTimeout(() => {
            AToolHomeSec.click();
        }, 500);
    }

    removeAboutLine(event){
        const target = event.target;
        const index = target.getAttribute("indeKV");
        this.state.AboutMeHome.ky995AMH.splice(index, 1);
        this.state.AboutMeHome.val995AMH.splice(index, 1);
        
        this.renderAbouteMeLines();
        this.renderAMH();

        ChangedData["AboutMeHome"] = this.state.AboutMeHome;

        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";
    }

    renderAbouteMeLines(){
        this.state.AboutMeHomeRenderKeysForATool =   this.state.AboutMeHome.ky995AMH.map( (title , index) => 
            <div className="d-flex justify-content-between align-items-center">
                <p className="ATOOLKeysAME" uitarget={index} onClick={this.clickToEditAtUi} onMouseOver={this.onHoverTargetElement} onMouseLeave={this.onHoverOutTargetElement} > { title } </p>   
                <img src={deleteIcone} className="deleteIcone" indeKV={index} onClick={this.removeAboutLine} />
            </div>
        );
    }

    renderAddNewAMLine(){
        const AddNewAML = document.getElementById("AddNewAML");
        AddNewAML.classList.remove("AddNewAMLZu");

        const addNewAMLInput = document.getElementsByClassName("addNewAMLInput");
        for (let i = 0; i < addNewAMLInput.length; i++) {
            addNewAMLInput[i].addEventListener("keydown" , ()=>{
                cheLength();
            });
        }

        function cheLength(){
            if (addNewAMLInput[0].value.length >= 1 && addNewAMLInput[1].value.length >= 1) {
                document.getElementById("AddNewLineBTN").classList.remove("OkAToolZu");
            }else{
                document.getElementById("AddNewLineBTN").classList.add("OkAToolZu");
            }
        }
    }

    AddNewLineBTNHandel(){
        // get Inputs
        const addNewAMLInput = document.getElementsByClassName("addNewAMLInput");
        // Values 
        const Key = addNewAMLInput[0].value;
        const Value = addNewAMLInput[1].value;
        // Change State
        this.state.AboutMeHome.ky995AMH.push(Key);
        this.state.AboutMeHome.val995AMH.push(Value);
        // Add To Changed Data
        ChangedData["AboutMeHome"] = this.state.AboutMeHome;
        // Redner Ui Elements
        this.renderAbouteMeLines();
        this.renderAMH();
        // Rest Inputs Values
        for (let i = 0; i< addNewAMLInput.length; i++) {
            addNewAMLInput[0].value = "";
        }
        // Hide Inputs Dive And Add Btn
        document.getElementById("AddNewLineBTN").classList.add("OkAToolZu");
        // Div
        const AddNewAML = document.getElementById("AddNewAML");
        AddNewAML.classList.add("AddNewAMLZu");
        // Show Save Data To Server
        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";

    }

    openDropFContainer(){
        if (localStorage.getItem("isLogged") == "true") {
            const DropFileContainer = document.getElementById("DropFileContainer");
            DropFileContainer.classList.remove("DropFileContainerZu");

            const DropFileBG = document.getElementById("DropFileBG");
            const BodyVisableZu = document.getElementById("BodyVisableZu");

            setTimeout(() => {
                DropFileBG.classList.remove("DropFileBGZu");
            }, 10);

            setTimeout(() => {
                BodyVisableZu.classList.remove("BodyVisableZu");
            }, 300);
        }
    }

    openDropFContainerAus(){
        const BodyVisableZu = document.getElementById("BodyVisableZu");
        BodyVisableZu.classList.add("BodyVisableZu");

        const DropFileBG = document.getElementById("DropFileBG");
        setTimeout(() => {
            DropFileBG.classList.add("DropFileBGZu");
        }, 10);

        setTimeout(() => {
            const DropFileContainer = document.getElementById("DropFileContainer");
            DropFileContainer.classList.add("DropFileContainerZu");
        }, 400);
    }

    renderAdminToolSec(){

        /*
        const Titles = AllData.SkillsTitles;

        for (let i = 0; i < Titles.length; i++) {
            // Create Elements
            const myskillsTOlAdcontainer = document.getElementById("myskillsTOlAdcontainer");
            const mainDiv = document.createElement("div");
            const ssgtt = document.createElement("div");
            const pLabel = document.createElement("p");
            const image = document.createElement("img");
            const classesMainDiv = ["elcontr" , "d-flex" , "justify-content-between" , "align-items-center"];

            // Append Child
            myskillsTOlAdcontainer.appendChild(mainDiv);
            mainDiv.appendChild(ssgtt);
            mainDiv.appendChild(pLabel);
            mainDiv.appendChild(image);

            // Add Classes
            for (let i = 0; i < classesMainDiv.length; i++) {
                mainDiv.classList.add(classesMainDiv[i]);
            }
            ssgtt.classList.add("ssgttssweww");
            pLabel.classList.add("elementTitle");
            image.classList.add("penToSquare");

            ssgtt.setAttribute("onClick" , "this.removeSkilssAb");
            // Add Events
            ssgtt.addEventListener("click" , ()=>{
                //this.removeSkilssAb();
            });
            ssgtt.addEventListener( "mouseover" , ()=>{
                //this.onHoverTargetElement();
            });
            ssgtt.addEventListener( "mouseout" , ()=>{
                // this.onHoverOutTargetElement();
            });
            
            // Add Attributs
            ssgtt.setAttribute("uitarget", `t${[i]}`);
            image.src = deleteIcone;
            pLabel.innerText = Titles[i];
        }

        */

        /*
            this.state.SkillsRendTitls = Titles.map( (Title , index) => <div className="elcontr d-flex justify-content-between align-items-center"> 
            <p className="elementTitle"> {Title} </p> 
            <img className="penToSquare RemoveSK" src={deleteIcone} onClick={this.removeSkilssAb} onMouseOver={this.onHoverTargetElement} onMouseOut={this.onHoverOutTargetElement} uitarget={`t${index}`}/>
            </div>)
        */

        const Titles = AllData.SkillsTitles;

        this.state.SkillsRendTitls = Titles.map( (Title , index)=>
        <div className="d-flex justify-content-between align-items-center">
        <p className="elementTitle sselementTitle" onClick={this.clickToEditAtUi}  onMouseOver={this.onHoverTargetElement} onMouseOut={this.onHoverOutTargetElement} uitarget={`t${index}`}> {Title} </p> 
            <img src={deleteIcone} className="deleteIcone RemoveSK" uitarget={`t${index}`} onClick={this.removeSkilssAb} />
        </div>);
    }

    removeSkilssAb(event){
        const element = event.target;
        const id = element.getAttribute("uitarget");
        let Index = id.substring(1 , id.index);

        AllData.SkillsDatain.skis.splice(Index , 1);

        AllData.SkillsTitles.splice(Index , 1);
        this.renderAdminToolSec();

        if (!AllData.SkillsTitles.length){
            document.getElementById("SkillsScreen").style.height = 0;
        }

    }

    OpenAddNewSkillHand(){
        this.setState({
            NewSkill: "" ,
        });
        const SkillsNewMainTitle = document.querySelector("#SkillsNewMainTitle");
        SkillsNewMainTitle.innerHTML = "";

        const AdSkillsCon = document.querySelector("#AdSkillsCon");
        const allATolSkillsTitles = document.querySelector("#allATolSkillsTitles");
        allATolSkillsTitles.classList.add("AddNnewSkillAus");
        AdSkillsCon.classList.remove("AddNnewSkillAus");

    }

    nextAADSkill(){
        const NewSkillContainer = document.querySelector("#NewSkillContainer");
        NewSkillContainer.classList.remove("addNewSkillContainerAus");

        const AdSkillsCon = document.querySelector("#addTitleSkill");
        AdSkillsCon.classList.add("AddNnewSkillAus");

        const mainTitleATool = document.querySelector("#mainTitleATool");
        let TitleValue = mainTitleATool.value;
        if (!TitleValue.length || TitleValue.replace(/\s+/g, '') == "") {
            TitleValue = "No Title...";
        }

        const SkillsNewMainTitle = document.querySelector("#SkillsNewMainTitle");
        SkillsNewMainTitle.innerHTML = TitleValue; 
        
        document.getElementById("NewSkill").classList.add("NewSkillAnn");
        document.getElementById("NewSkill").classList.remove("NewSkillAnnAus");


        mainTitleATool.value = "";
    }

    renderAToolSkillsCardName(){
        let rend = this.state.ATSkillsCards.map( title =>  <div>
            <li className="NewSkillNameATool" style={{ color: title.color }}> { title.SkillName } </li>
        </div> );
        this.setState({
            NewSkill : rend
        });
    }

    AddMorSk(){
        const NewSkillContainer = document.querySelector("#NewSkillContainer");
        NewSkillContainer.classList.remove("addNewSkillContainerAus");

        const AddedSuAtol = document.querySelector("#AddedSuAtol");
        AddedSuAtol.classList.add("addNewSkillContainerAus");
    }

    AddSkillF(){
        const obj = {
            "SkillName" : "",
            "color" : "" ,
            "SkillsRange" : "" ,
            "SkillLogo" : "" 
        }

        const SkillNameInput = document.querySelector("#SkillNameInput");
        const raaangeINPUT = document.querySelector("#raaangeINPUT");
        const SkillColor = document.querySelector("#SkillColor");

        obj.SkillName = SkillNameInput.value;
        obj.SkillsRange = raaangeINPUT.value + "%";
        obj.color = SkillColor.value;

        this.state.ATSkillsCards.push(obj);

        const NewSkillContainer = document.querySelector("#NewSkillContainer");
        NewSkillContainer.classList.add("addNewSkillContainerAus");

        const AddedSuAtol = document.querySelector("#AddedSuAtol");
        AddedSuAtol.classList.remove("addNewSkillContainerAus");

        SkillNameInput.value = "";
        raaangeINPUT.value = "";
        SkillColor.value = "";

        const OkButton = document.querySelector("#OkButtonSkills");
        OkButton.classList.remove("OkButtonAUS");

        this.renderAToolSkillsCardName();
    }

    FinishAddingSkills(){
        let mobj = {
            "SkillTitle" : "",
            "SkillsCards": []
        }
        const mainTitleATool = document.querySelector("#mainTitleATool");
        mobj.SkillTitle = mainTitleATool.value;
        let all = this.state.ATSkillsCards;
        for (let i = 0; i < all.length; i++) {
            mobj.SkillsCards.push(all[i]);
        }
        skill = mobj;

        /////////////////////////////////////////////////////////////////////////////
        // Add More Hide
        const AdSkillsCon = document.querySelector("#AdSkillsCon");
        const allATolSkillsTitles = document.querySelector("#allATolSkillsTitles");
        allATolSkillsTitles.classList.remove("AddNnewSkillAus");
        AdSkillsCon.classList.add("AddNnewSkillAus");
        // 
        document.getElementById("NewSkill").classList.add("NewSkillAnnAus");
        this.renderAToolSkillsCardName();
        //
        const OkButton = document.querySelector("#OkButtonSkills");
        OkButton.classList.add("OkButtonAUS");
        //
        const NewSkillContainer = document.querySelector("#NewSkillContainer");
        NewSkillContainer.classList.add("addNewSkillContainerAus");
        //
        const AddedSuAtol = document.querySelector("#AddedSuAtol");
        AddedSuAtol.classList.add("addNewSkillContainerAus");
        //
        const AdSkillsCon2 = document.querySelector("#addTitleSkill");
        AdSkillsCon2.classList.remove("AddNnewSkillAus");
        /////////////////////////////////////////////////////////////////////////////
    }

    renderContactTitles(){
        this.state.ConcatTitlesATool = AllData.ContactD.Cards.map( (card , index) => 
            <div className="d-flex justify-content-between align-items-center">
            <p className="elementTitle sselementTitle" onClick={this.clickToEditAtUi}  onMouseOver={this.onHoverTargetElement} onMouseOut={this.onHoverOutTargetElement} uitarget={`cadkey${index}`}> {card.key} </p> 
                <img src={deleteIcone} className="deleteIcone ConttTilsAT" uitarget={`cadkey${index}`} onClick={this.removeContactCard} />
            </div>
        );
    }

    removeContactCard(event){
        const element = event.target;
        const id = element.getAttribute("uitarget");
        let indexID = id.substring(6 , id.length);

        setTimeout(() => {
            this.renderContactTitles();
        }, 100);
        setTimeout(() => {
            this.renderContactTitles();
        }, 500);
        AllData.ContactD.Cards.splice(indexID , 1);

        // Show Save Data To Server
        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";

        ChangedData["ContactD"] = AllData["ContactD"]
    }

    addNewContactCard(){
        // Hide Titls Container
        const allCardsTitleContainer = document.getElementById("allCardsTitleContainer");
        allCardsTitleContainer.classList.add("NoneNodeClass");
        // show adding Container
        const AdddingCCardATool = document.getElementById("AdddingCCardATool");
        AdddingCCardATool.classList.remove("NoneNodeClass");
    }

    OKAddContactCardBTN(){
        const logos = {
            "email" : "https://oderasid.com/myWebSiteSRC/Icons/envelope-solidC.png",
            "phone" : "https://oderasid.com/myWebSiteSRC/Icons/phone-solidC.png" ,
            "Adresse" : "https://oderasid.com/myWebSiteSRC/Icons/phone-solidC.png" ,
            "website" : "https://oderasid.com/myWebSiteSRC/Icons/edge-brandsC.png" 
        }

        const obj = {
            "logo": "",
            "key": "",
            "value": "",
            "link": ""
        };

        const selectTypeA = document.getElementById("selectTypeA");
        const inputCCATTolKey = document.getElementById("inputCCATTolKey");
        const inputCCATTolValue = document.getElementById("inputCCATTolValue");

        obj.key = inputCCATTolKey.value;
        obj.value = inputCCATTolValue.value;
        obj.link = selectTypeA.value + inputCCATTolValue.value;
        
        switch (selectTypeA.value) {
            case "tel:": obj.logo = logos.phone; break;
            case "mailto" : obj.logo = logos.email; break;
            case "http://" : obj.logo = logos.website; break; 
            default: 
                break;
        }

        AllData["ContactD"]["Cards"].push(obj);
        ChangedData["ContactD"] = AllData["ContactD"];

        // Render Titels In Admin Tool
        this.renderContactTitles();

        // show Titls Container
        const allCardsTitleContainer = document.getElementById("allCardsTitleContainer");
        allCardsTitleContainer.classList.remove("NoneNodeClass");
        // hide adding Container
        const AdddingCCardATool = document.getElementById("AdddingCCardATool");
        AdddingCCardATool.classList.add("NoneNodeClass");

        // Reset input Values
        inputCCATTolKey.value = "";
        inputCCATTolValue.value = "";

        // Show Save Data To Server
        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";
    }

    rendFormInputs(){
        const values = [ AllData.ContactD.Iname , AllData.ContactD.Iemail , AllData.ContactD.Isub , AllData.ContactD.Imsg ];
        const idd = [ "Iname" , "Iemail" , "Isub" , "Imsg" ];

        const TitleofFormsAT = document.getElementById("TitleofFormsAT");
        for (let i = 0; i < values.length; i++) {
            const myDiv = document.createElement("div");
            const myInput = document.createElement("input");
            myDiv.appendChild(myInput);
            myInput.classList.add("inputBer");
            myInput.classList.add("inputBerFI");
            myInput.type = "text";
            myInput.value = values[i];
            myInput.id = idd[i];

            myDiv.style.marginTop = "20px"

            TitleofFormsAT.appendChild(myDiv);

            myInput.addEventListener("keydown" , ()=>{
                setTimeout(() => {
                    AllData.ContactD[myInput.id] = myInput.value;
                    ChangedData["ContactD"] = AllData.ContactD;
                    // Show Save Data To Server
                    let SaveChangContainer = document.getElementById("SaveChangContainer");
                    SaveChangContainer.style.visibility = "visible";
                }, 200);
            })
        }
    }






















    












    render(){

        return(
            <div className="AllBody AllBodyAus" id="AllBody">

            <div className="asdasd DropFileContainerZu" id="DropFileContainer">

                <div className="DropFileBG DropFileBGZu" id="DropFileBG" onClick={this.openDropFContainerAus}>

                </div>
                <div className="BodyVisableZu BodyVisable" id="BodyVisableZu">
                    <DropFiles />
                </div>

            </div>

            <div id="AdminTools">

                <div className="AdminTool AdminToolZuu AdminToolOpen" id="AdminTool">
                <div className="closeOpenSetting d-flex align-items-center justify-content-center"  onClick={this.ToolsZu}  >
                    <i className="fas fa-cog editIconAT" id="editIconAT"></i>
                </div>

                <div className="ToolsAdmionMainContainer">
                    <div className="mainHeaderAdminTool">
                        <p className="TitleAdminPanel">Admin Panel</p>
                    </div>

                    <div className="ToolBody">

                        <div className="allSectiosContainer" id="allSectiosContainer" >
                            <p className="psecs">Page sections</p>
                            <div className="secsContainer">
                                <a href="/#Home" id="HomeAAT" ><div className=" d-flex  justify-content-between align-items-center sescDivItem" > <div id="AToolHomeSec" className="ssgttssweww" ToolA="AdminToolSecessAnimations"  onClick={this.ToolSectionsHandel}></div> <p className="SecsTitle">Home</p> <img src={angleRightSolid} className="angleRightSolid" />  </div></a>
                                <a href="/#About"> <div className=" d-flex  justify-content-between align-items-center sescDivItem"> <div className="ssgttssweww" ToolA="AToolAbouteMe"  onClick={this.ToolSectionsHandel}></div>  <p className="SecsTitle">About me</p> <img src={angleRightSolid} className="angleRightSolid" />  </div></a>
                                <a href="/#Skills"><div className=" d-flex  justify-content-between align-items-center sescDivItem"> <div className="ssgttssweww" ToolA="AToolSkills"  onClick={this.ToolSectionsHandel}></div>  <p className="SecsTitle" >Skills</p>  <img src={angleRightSolid} className="angleRightSolid" />  </div></a>
                                <a href="/#Contact"><div className=" d-flex  justify-content-between align-items-center sescDivItem"> <div className="ssgttssweww" ToolA="AToolContact"  onClick={this.ToolSectionsHandel}></div> <p className="SecsTitle">Contact</p> <img src={angleRightSolid} className="angleRightSolid" />  </div></a>
                            </div>
                            <div className="ADMINFuccDiv">
                                <div className="BTNAdminTools d-flex align-items-center justify-content-center" > Account settings </div>
                                <div className="BTNAdminTools d-flex align-items-center justify-content-center" > Log out </div>
                            </div>
                        </div>


                        { /* ///////////////////////////////////     Home     //////////////////////////////////////// */ }
                        <div className="AToolHomeMainContainer AdminToolSecessAnimations" id="AdminToolSecessAnimations" >
                            <div className="sklskzsssssss  d-flex align-items-center justify-content-between">
                                <p className="HTATool ">Edit Home</p>
                                <img src={xmark} className="xmarkIcon" onClick={this.CloseToolSectionsHandel} ToolA="AdminToolSecessAnimations"/>
                            </div>

                            <div className="AToolHomeContainer ">
                                <div className="elcontr d-flex justify-content-between align-items-center"> <div className="ssgttssweww" onClick={this.clickToEditAtUi} onMouseOver={this.onHoverTargetElement} onMouseOut={this.onHoverOutTargetElement} uitarget="Hey"></div> <p className="elementTitle">Welcome sentence</p> <img className="penToSquare" src={penToSquare} /> </div>
                                <div className="elcontr d-flex justify-content-between align-items-center"> <div className="ssgttssweww" onClick={this.clickToEditAtUi} onMouseOver={this.onHoverTargetElement} onMouseLeave={this.onHoverOutTargetElement} uitarget="Name"></div> <p className="elementTitle">My name</p> <img className="penToSquare" src={penToSquare} /> </div>
                                <div className="elcontr d-flex justify-content-between align-items-center"> <div className="ssgttssweww" onClick={this.clickToEditAtUi} onMouseOver={this.onHoverTargetElement} onMouseLeave={this.onHoverOutTargetElement} uitarget="iama"></div> <p className="elementTitle">I'm a sentence</p> <img className="penToSquare" src={penToSquare} /> </div>
                                <div className="HeaderInputsContainerBerAT  d-flex justify-content-between align-items-center" onMouseOver={this.onHoverTargetElement} onMouseOut={this.onHoverOutTargetElement} uitarget="berufe">
                                    <span className="marginTopss" onMouseOver={this.onHoverTargetElement} onMouseLeave={this.onHoverOutTargetElement} uitarget="berufe">My professions</span>
                                    <img className="AddIcon" src={plusSolid} onClick={this.addNewBeruf} onMouseOver={this.onHoverTargetElement} onMouseLeave={this.onHoverOutTargetElement} uitarget="berufe" />    
                                </div>
                                <div className="InputsContainerBerAT" id="InputsContainerBerAT">
                                </div>  

                                <div className="HomeTypeTiming HeaderInputsContainerBerAT">
                                    <div className="fullWidth d-flex justify-content-between align-items-center"> <span>Write Timer</span> <img src={hourglass} className="AddIcon" /> </div>
                                    <div className="sawwwfd" id="renderTAT">
                                        {/* <div> <span className="LableTAT">Writing speed: </span> <input className="TimerInputs" /> <span className="LableTAT">mm</span> </div> */}
                                    </div>
                                </div>


                            </div>

                            <div className="OkAToolZu OkATool d-flex justify-content-center align-items-center " id="OkATool" onClick={this.OkAdminToolBTN}>
                                    <span>OK</span>
                            </div>
                        </div>


                        { /* ///////////////////////////////////     About     //////////////////////////////////////// */ }
                        <div className="AToolHomeMainContainer AToolAbouteMe" id="AToolAbouteMe" >
                            <div className="sklskzsssssss  d-flex align-items-center justify-content-between">
                                <p className="HTATool ">Edit About me</p>
                                <img src={xmark} className="xmarkIcon" onClick={this.CloseToolSectionsHandel} ToolA="AToolAbouteMe"/>
                            </div>

                            <div className="AToolHomeContainer ">
                                <div className="elcontr d-flex justify-content-between align-items-center"> <div className="ssgttssweww" onClick={this.clickToEditAtUi} onMouseOver={this.onHoverTargetElement} onMouseOut={this.onHoverOutTargetElement} uitarget="tOPMT"></div> <p className="elementTitle">About me Title</p> <img className="penToSquare" src={penToSquare} /> </div>
                                <div className="elcontr d-flex justify-content-between align-items-center"> <div className="ssgttssweww" onClick={this.clickToEditAtUi} onMouseOver={this.onHoverTargetElement} onMouseOut={this.onHoverOutTargetElement} uitarget="ULABELDES"></div> <p className="elementTitle">About me Under Title</p> <img className="penToSquare" src={penToSquare} /> </div>
                            
                            
                                <div className="HomeTypeTiming HeaderInputsContainerBerAT">
                                    <div className="fullWidth d-flex justify-content-between align-items-center"> <span>About me Lines</span> <img src={plusSolid} className="AddIcon" onClick={this.renderAddNewAMLine} /> </div>

                                    <div className="AddNewAML AddNewAMLZu" id="AddNewAML">
                                        <div>
                                            <div>
                                                <p className="LableAMLI">Title: </p>
                                                <input type="text" className="addNewAMLInput"/>
                                            </div>
                                            <div>
                                                <p className="LableAMLI">Value: </p>
                                                <input type="text" className="addNewAMLInput"/>
                                            </div>
                                            <div className="OkATool OkAToolZu d-flex justify-content-center align-items-center" id="AddNewLineBTN" onClick={this.AddNewLineBTNHandel}>
                                                    <span>Add</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="sawwwfd" id="">
                                        { this.state.AboutMeHomeRenderKeysForATool }
                                    </div>
                                </div>
                            </div>

                            
                        </div>



                        
                        { /* ///////////////////////////////////     Skills     //////////////////////////////////////// */ }
                        <div className="AToolHomeMainContainer AToolSkills" id="AToolSkills" >
                            <div className="sklskzsssssss  d-flex align-items-center justify-content-between">
                                <p className="HTATool ">Edit my Skiils</p>
                                <img src={xmark} className="xmarkIcon" onClick={this.CloseToolSectionsHandel} ToolA="AToolSkills"/>
                            </div>

                            <div className="AToolHomeContainer">

                                <div className="fullWidth d-flex justify-content-between align-items-center allmskclas"> <span>All My Skills</span> <img src={plusSolid} className="AddIcon" onClick={this.OpenAddNewSkillHand}/> </div>
                                <div id="myskillsTOlAdcontainer">


                                <div className="AddNnewSkill AddNnewSkillAus" id="AdSkillsCon">
                                        <div className="" id="addTitleSkill">
                                            <div className="Titcon">
                                                <p className="SkATTTile">main Title</p>
                                                <input type="text" className="addNewAMLInput" id="mainTitleATool" />
                                            </ div>
                                            <div className="OkButton d-flex align-items-center justify-content-center" onClick={this.nextAADSkill}>Next</div>
                                        </div>

                                        {/** 
                                        <div className="swwjjjn d-flex align-items-center">
                                            <p className="a23sssa">Add New Skill</p>
                                            <img src={plusSolid} className="AddIcon" />
                                        </div>
                                        */}

                                        <div className="addNewSkillContainer addNewSkillContainerAus" id="NewSkillContainer">
                                            <div className="sdwwqkk d-flex align-items-center ">
                                                <p className="ASkATTTile">Skill Name:</p>
                                                <input type="text" className="addNewAMLInput" id="SkillNameInput"/>
                                            </div>
                                            <div className="sdwwqkk d-flex align-items-center justify-content-between">
                                                <p className="ASkATTTile">Rang in %:</p>
                                                <input type="number" className="addNewAMLInput" min="1" max="100" id="raaangeINPUT" />
                                            </div>
                                            <div className="sdwwqkk d-flex align-items-center justify-content-between">
                                                <p className="ASkATTTile">Color:</p>
                                                <input type="color" id="SkillColor"/>
                                            </div>
                                            <div className="sdwwqkk d-flex align-items-center justify-content-between">
                                                <p className="ASkATTTile">Logo:</p>
                                                <img src={plusSolid} className="AddIcon" onClick={this.openDropFContainer} />
                                            </div>
                                            <div className="OkButton d-flex align-items-center justify-content-center" onClick={this.AddSkillF} id="AddSkillF" >Add Skill</div>
                                        </div>

                                        <div className="addNewSkillContainerAus" id="AddedSuAtol">
                                            <p className="addMo">This skill has been added.</p>
                                            <div className="OkButton d-flex align-items-center justify-content-center" onClick={this.AddMorSk} >Add one More</div>
                                        </div>

                                    </div>

                                    <div className="NewSkill" id="NewSkill">
                                        <p id="SkillsNewMainTitle"></p>
                                        { this.state.NewSkill }
                                    </div>
                                    <div id="allATolSkillsTitles">
                                        {this.state.SkillsRendTitls}
                                    </div>

                                    

                                </div>

                                <div className="OkButton OkButtonSk OkButtonAUS d-flex align-items-center justify-content-center" onClick={this.FinishAddingSkills} id="OkButtonSkills" >Finish adding skills</div>
                            </div>

                        </div>


                        { /* ///////////////////////////////////     Contact     //////////////////////////////////////// */ }
                        <div className="AToolHomeMainContainer AToolContact" id="AToolContact" >
                            <div className="sklskzsssssss  d-flex align-items-center justify-content-between">
                                <p className="HTATool ">Edit Contact</p>
                                <img src={xmark} className="xmarkIcon" onClick={this.CloseToolSectionsHandel} ToolA="AToolContact"/>
                            </div>

                            <div className="swwjjjn swwjjjn2  d-flex align-items-center justify-content-between">
                                <p className="a23sssa">Add New</p>
                                <img src={plusSolid} className="AddIcon" onClick={this.addNewContactCard} />
                            </div>

                            <div className="AdddingCCardATool NoneNodeClass" id="AdddingCCardATool">

                                <div className="selectTypeAContainer  d-flex align-items-center justify-content-between">
                                    <p className="ASkATTTileCC">Choose Type:</p>
                                    <select id="selectTypeA" name="selectTypeA">
                                        <option value="tel:">Telefon</option>
                                        <option value="mailto:">Email</option>
                                        <option value="http://" selected>website</option>
                                        <option value="other">other</option>
                                    </select>
                                </div>

                                <div className="sdwwqkk d-flex align-items-center justify-content-between">
                                    <p className="ASkATTTileCC">Card Title</p>
                                    <input type="text" className="addNewAMLInput" id="inputCCATTolKey" />
                                </div>

                                <div className="sdwwqkk d-flex align-items-center justify-content-between">
                                    <p className="ASkATTTileCC">The Value</p>
                                    <input type="number" className="addNewAMLInput" id="inputCCATTolValue" />
                                </div>

                                <div className="sdwwqkk d-flex align-items-center justify-content-between">
                                    <p className="ASkATTTileCC">Custem Logo?</p>
                                    <img src={plusSolid} className="AddIcon" onClick={this.openDropFContainer} />
                                </div>

                                <div className="OkATool d-flex justify-content-center align-items-center" id="OkAddCardC" onClick={this.OKAddContactCardBTN}>
                                    <span>Add</span>
                                </div>


                            </div>

                            <div className="AToolHomeContainer  AToolHomeContainer2" id="allCardsTitleContainer">
                                { this.state.ConcatTitlesATool }

                                <div className="editFormInputs">
                                    <p className="TitleofFormsAT" id="TitleofFormsAT">Form Inputs</p>
                                </div>


                            </div>
                        </div>

                    </div>

                </div>

            </div>
            </div>
            


            
            <div className="BodyScroll">
                <div className="SaveChangContainer" id="SaveChangContainer">
                    <div className="BodySaveC d-flex justify-content-between align-items-center"> <div><p className="TitleSCSC">Do you want to save changes</p></div> <div className="savecloseBTNS d-flex justify-content-between align-items-center"> <div className="SaveBTN d-flex justify-content-center align-items-center" id="SaveBTN" onClick={this.uploadChangedDataToServer}>Save</div> <div className="CloseBTN d-flex justify-content-center align-items-center" id="CloseBTN" onClick={this.CloseSaveChange}>Close</div> </div> </div> 
                </div>
                <MainHeaderr />
                <div className="DivH">

                <div id="Home" className="HomeRout"></div>

                <div className="WSSleft" style={{ backgroundColor: this.state.DataH.BGColorWSSleft }} >
                    <div className="mainContainerthe4ecToScroll d-flex align-items-center justify-content-center"  style={{ backgroundColor: this.state.DataH.BGColorWSSleft }}>
                        <a href="#sec2" className="the4ecToScroll" id="the4ecToScroll"></a>
                        
                        <div>
                            <a href="#"><i className="fas fa-long-arrow-alt-down ArrowScrollIcoc"></i></a>
                        </div>

                    </div>
                
                </div>

                <div className="WelcomScreenContainer d-flex flex-column align-items-center justify-content-center" id="WelcomScreenContainer">
                                                <p className="HeyP1 toTextEdit" data-f="HomeData" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} linke="Hey" id="Hey" style={{ color: this.state.DataH.HColor }} > { this.state.DataH.Hey } </p>
                                    <p className="MyNameWSCreen toTextEdit"  data-f="HomeData" id="Name" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} style={{ color: this.state.DataH.NColor }}>{ this.state.DataH.Name }</p>
                                    <div className="d-flex">
                                        <p className="iamP" data-f="HomeData" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} id="iama" style={{ color: this.state.DataH.IacOLOR }}>{ this.state.DataH.iama }</p>
                                        <span> &nbsp;</span>
                                        <span id="berufe" className="iamP BerSpanTxt toTextEdit" data-f="HomeData" onClick={this.openBerufeEdit} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} style={{ color: this.state.DataH.MBColor }} > { this.state.myBeruf } </span>
                                    </div> 
                </div>
                </div>



                <div className="DivH">
                
                    <div id="About" className="ScreenRouteDiv"></div>
                    <div className="AboutMeScreen d-flex justify-content-center align-items-center fade-up">
                    <div className="AboutemeContainer  d-flex justify-content-center align-items-center flex-wrap">

                        <div className="ImagePersonContainer" onClick={this.openDropFContainer} >
                            <img className="PAImage" src={myFoto} alt="me" id="PAImage"  />
                        </div>

                        <div className="AbuteMeInfoDiv" id="AbuteMeInfoDiv">
                            <p className="AbuteMeLableTop" data-f="AboutMeHome" onClick={this.toTextEditFunction}  id="tOPMT"  onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut}> { this.state.AboutMeHome.tOPMT } </p>
                            <p className="aboutemeunderTitle" onClick={this.toTextEditFunction} data-f="AboutMeHome" id="ULABELDES"  onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut}>
                                {this.state.AboutMeHome.ULABELDES}
                            </p>

                            <div className="d-flex align-items-center ">

                                <div className="dfssa" id="keyys995">
                                    { this.state.AboutMeHomeRender }
                                </div>

                                <div>
                                   { this.state.AboutMeHomeRenderValues }
                                </div>
                            </div>


                            <a href="/cv">
                                <div className="o-btn d-flex align-items-center justify-content-center" id="CVbtn">Lebenslauf</div>
                            </a>
                        </div>

                        
                    </div>
                    </div>
                </div>
          

                <div id="mySkillsComp" className="DivH">{ this.mySkills } </div>
                <div id="MyBlogHomeComp" className="DivH"> <MyBlogHome /></div>
                <div id="AvilableCardComp"> <AvilableCard /> </div>
                <div id="ContactHomeComp" className="DivH"> <ContactHome /> </div>
                <div id="MainFooterComp"> <MainFooter /> </div>

                <div className="alert myAlert alert-danger d-flex align-items-center" role="alert" id="AlertError" >
                    <div className="" id="AlertMessage">
                    </div>
                </div>

            </div>
            </div>
        );
    }


}


export default Home;